module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/word-fbe4137f4fd435af1161f88aeb5ffa0a.svg";